import React, { useEffect, useState } from 'react';
import { GrUserWorker } from 'react-icons/gr';
import { BackendLink, SmartProjectCard } from '../../../Components';
import './LastProjectsSec.css';

const LastProjectsSec = () => {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await fetch(`${BackendLink}/AllProjects/`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setProjects(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchProjects();
    }, []);

    // Filter the important projects
    const importantProjects = projects.filter(project => project.important);

    return (
        <div className='LastProjectsSec'>
            <h1 className='LastProjectsSec-title' data-aos="fade-up">
                <GrUserWorker />
                Projects
            </h1>
            <ul className="allLast-projects" data-aos="fade-up">
                {loading ? (
                    Array.from({ length: 3 }).map((_, idx) => (
                        <SmartProjectCard
                            key={idx}
                            loading={true}
                            error={false}
                            project={null}
                        />
                    ))
                ) : error ? (
                    Array.from({ length: 3 }).map((_, idx) => (
                        <SmartProjectCard
                            key={idx}
                            loading={false}
                            error={true}
                            project={null}
                        />
                    ))
                ) : importantProjects.length > 0 ? (
                    importantProjects.map(project => (
                        <SmartProjectCard
                            key={project.id}
                            loading={false}
                            error={false}
                            project={project}
                        />
                    ))
                ) : (
                    Array.from({ length: 3 }).map((_, idx) => (
                        <SmartProjectCard
                            key={idx}
                            loading={false}
                            error={true}
                            project={null}
                        />
                    ))
                )}
            </ul>
        </div>
    );
};

export default LastProjectsSec;
